import { useFormikContext } from 'formik';
import React, { FC, useEffect, useState } from 'react';
import OutsideClick from '../outside-click/outside-click';
import Paginator from '../paginator/paginator';
import SearchableList from '../searchable-list/menu-searchable-list';
import arrowIcon from '../../images/Down Arrow.svg';
import { PaginationModel } from '../../models/Pagination';
import { useWizardSummaryContext } from '../wizard/wizardSummaryContext';
import { Name } from '../../models/Name';
import { DEF_PG_SIZE_DROP_DOWN } from '../../constants/maximum-page-size';


export interface SelectListFieldProps {
    accessor: string;
    options: Name[];
    onSelect: (item) => void;
    pageSize?: number;
}

/**
 * Select list field (supports only single item selection currently)
 * @param param0
 * @returns
 */
export const SelectListField: FC<SelectListFieldProps> = ({ accessor, options, onSelect, pageSize = DEF_PG_SIZE_DROP_DOWN }) => {
    const [open, setOpen] = useState(false);
    const [selectionLabel, setSelectionLabel] = useState('-');
    const [pagination, setPagination] = useState<PaginationModel>({
        totalCount: options.length,
        maxPageSize: pageSize,
        totalPages: options.length / pageSize,
        pageNumber: 1
    });
    const [selectedItems, setSelectedItems] = useState(new Array(0));
    const [selectedOption, setSelectedOption] = useState({ label: '', value: '' });
    const { setFieldValue, values } = useFormikContext();
    const { updateSummary } = useWizardSummaryContext();

    useEffect(() => {
        setPagination({
            ...pagination,
            totalCount: options.length,
            totalPages: options.length / pageSize,
        })
    }, [options.length > 0 === false])

    useEffect(() => {
        if (accessor.split('.').reduce((previous, current) => previous?.[current], values as any)) {
            const selectedId = accessor.split('.').reduce((previous, current) => previous?.[current], values as any);
            const selectedItem = options.find(item => item.value === selectedId);
            handleItemSelected(+selectedId, selectedItem);
        }
    }, [!!accessor.split('.').reduce((previous, current) => previous?.[current], values as any) === false])

    const handlePageNumberUpdate = (newPageNumber) => {
        const visibleOptions = options.slice((newPageNumber - 1) * pageSize, (newPageNumber * pageSize) > options.length ? options.length : (newPageNumber * pageSize));
        const indexOfSelectedItem = visibleOptions
            .findIndex(displayOption => {
                return selectedOption?.value === displayOption.value;
            });
        setSelectedItems(indexOfSelectedItem >= 0 ? [indexOfSelectedItem] : []);
        setPagination({ ...pagination, pageNumber: newPageNumber });
    };

    const handleSelection = () => { };
    const handleItemSelected = (index, item) => {
        setFieldValue(accessor, item?.value);
        setSelectionLabel(item?.label);
        setSelectedOption(item);
        setSelectedItems([index]);
        updateSummary(accessor, item?.label);
        onSelect(item);
    };

    return <OutsideClick onClick={() => setOpen(false)}>
        <button type="button"
            className={`bg-gray-input w-full p-1 px-2 text-left flex flex-row justify-between text-sm min-width-48`} // ${className}`}
            onClick={() => setOpen(!open)}>
            <span>{selectionLabel}</span>
            <img className="pl-2 select-field--arrow" src={arrowIcon} alt=""></img>
        </button>
        <div className={`relative mx-1 ${open ? '' : 'hidden'}`}>
            <div className="fixed bg-white shadow-md -mr-3 rounded-md px-2 py-2 z-50" id='searchColumnFilterModel'>
                <Paginator
                    itemCount={options.length}
                    onPageNumberUpdated={handlePageNumberUpdate}
                    onPageSizeUpdated={() => { }}
                    paginationObj={pagination}
                    sizes={[]}>
                    {({ start, end }) => (
                        <SearchableList
                            items={options.slice(start, end + 1).map((item, index) => <div className="flex flex-row flex-grow items-center cursor-pointer"
                                onClick={() => handleItemSelected(index, item)}>
                                <div className="">{item.label}</div>
                            </div>
                            )}
                            title={''}
                            onSelect={handleSelection}
                            searchBoxClassName="mb-4"
                            titleClassName="mb-0"
                            stripedListClassName="mb-2"
                            stripedListItemClassName="p-1 pl-3"
                            selectedListItemClassName="p-1 pl-1-5 border-l-7 border-portal-blue-primary bg-selection-highlight border-t-selection-highlight border-r-selection-highlight border-b-selection-highlight"
                            isMultiSelect={false}
                            selectedItems={selectedItems}></SearchableList>
                    )}
                </Paginator>
            </div>
        </div>
    </OutsideClick>;
};
